import { Button, Card, Col, Table } from "reactstrap";
import { AddProjectsAndUploadTitle, Delete, Edit, Href, Update } from "../../../../../constants";
import { Project } from "../../../../../data/applications/Users";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const Projects = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={AddProjectsAndUploadTitle} headClass={"pb-3"}/>
        <div className="table-responsive add-project">
          <Table>
            <thead className="bg-light-primary">
              <tr>
                <th>ProjectName</th>
                <th>Date</th>
                <th>Status</th>
                <th>Price</th>
                <th />
              </tr>
            </thead>
            <tbody>
            { Project.map((data, index) => (
              <tr key={index}>
                <td className="add-project"><a className="text-inherit" href={Href}>Untrammelled Prevents</a></td>
                <td>{data.date}</td>
                <td><span className={`${data.statusClass}`} /> {data.status}</td>
                <td>{data.price}</td>
                <td className="text-end">
                  <Button color="primary" tag="a" size="sm" href={Href}><i className="fa fa-pencil"/> {Edit}</Button>
                  <Button color="transparent" tag="a" size="sm" href={Href}><i className="fa fa-link"/> {Update}</Button>
                  <Button color="danger" tag="a" size="sm" href={Href}><i className="fa fa-trash"/> {Delete}</Button>
                </td>
              </tr>
            ))}
          </tbody>
          </Table>
        </div>
      </Card>
    </Col>
  );
};

export default Projects;
